import React from 'react'

import ChevronLeftIcon from '../Icons/ChevronLeftIcon'
import ChevronRightIcon from '../Icons/chevronRightIcon'
import styles from './Pagination.module.scss'

const Pagination = ({ totalPages, activePageIndex, onPageChange }) => {
  if (totalPages <= 1) {
    return null
  }
  const generatePageNumbers = () => {
    const pageNumbers = []

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i)
      }
    } else {
      pageNumbers.push(1)

      if (activePageIndex < 3) {
        pageNumbers.push(2, 3, '...', totalPages)
      } else if (activePageIndex >= totalPages - 3) {
        pageNumbers.push('...', totalPages - 2, totalPages - 1, totalPages)
      } else {
        pageNumbers.push('...', activePageIndex, activePageIndex + 1, '...', totalPages)
      }
    }

    return pageNumbers
  }

  const pageNumbers = generatePageNumbers()

  return (
    <div className={styles.paginationContainer}>
      <div
        className={`${styles.navButtonContainer} ${
          activePageIndex === 1 ? styles.disabled : ''
        }`}
        onClick={
          activePageIndex !== 1 ? () => onPageChange(activePageIndex - 1) : undefined
        }
      >
        <button disabled={activePageIndex === 1} className={styles.navButton}>
          <ChevronLeftIcon />
        </button>
      </div>

      {pageNumbers.map((pageNumber, index) => (
        <React.Fragment key={index}>
          {pageNumber === '...' ? (
            <span className={styles.ellipsis}>...</span>
          ) : (
            <button
              onClick={() => onPageChange(pageNumber)}
              className={`${styles.pageButton} ${
                pageNumber === activePageIndex ? styles.active : ''
              }`}
            >
              {pageNumber}
            </button>
          )}
        </React.Fragment>
      ))}

      <div
        className={`${styles.navButtonContainer} ${
          activePageIndex === totalPages ? styles.disabled : ''
        }`}
        onClick={
          activePageIndex !== totalPages
            ? () => onPageChange(activePageIndex + 1)
            : undefined
        }
      >
        <button disabled={activePageIndex === totalPages} className={styles.navButton}>
          <ChevronRightIcon />
        </button>
      </div>
    </div>
  )
}

export default Pagination
